import type { VariantPage } from "@/lib/api/formatting/rorosTweed/productPage";
import type { PriceAndSize } from "@/lib/centra/selection/selectionFormatter";

import UI from "./UI";

type InfoProps = VariantPage["info"] & {
  addPriceAndSize: PriceAndSize;
  gtagAddToCart: () => void;
};

const Info = (props: InfoProps) => {
  return (
    <>
      <UI {...props} />
    </>
  );
};

export default Info;
